import React from 'react';
import Layout from '../components/layout/Layout';

const ColumbiaTerms = () => {
  return (
    <Layout>
      <main class="mt-10 mb-8 md:mb-32 mx-auto max-w-screen-xl px-4 sm:mt-12 sm:px-6 md:mt-16 lg:mt-20 xl:mt-28">
        <div class="text-center">
          <h2 class="text-4xl tracking-tight leading-10 font-extrabold text-gray-900 sm:text-5xl sm:leading-none md:text-4xl">
            TERMS AND CONDITIONS OF SERVICE
          </h2>
          <p class="text-left mt-3 mx-auto text-base text-blue sm:text-lg md:mt-5 md:text-sm ">
            By receiving service from Kratos Gas & Power (Kratos), the customer agrees to be bound
            by the terms and conditions as set forth in this Terms and Conditions of Service,
            effective April 8, 2021.
          </p>

          <h2 class="mt-8 text-left text-4xl font-extrabold text-gray-900 sm:text-5xl sm:leading-none md:text-xl">
            DEFINITIONS
          </h2>
          <p class="md:pl-12 text-left mt-3 mx-auto text-base text-blue sm:text-lg md:mt-5 md:text-sm ">
            • Residential customer or consumer: premises at which natural gas is consumed primarily
            for personal, family or household use. <br></br>• Commercial and industrial (C&I)
            customer: a premises with commercial/industrial service as defined in COH’s tariff on
            file with the PUCO. <br></br> • Kratos Gas & Power (Kratos): a natural gas marketing
            company. Kratos buys gas from energy producers and marketers and in turn sells that gas
            to consumers. <br></br>• Columbia Gas of Ohio’s COH, the utility regulated by the PUCO.
            COH distributes natural gas on behalf of Kratos and other marketers, maintains the gas
            pipeline system, and responds to gas leaks and other emergencies. <br></br>• Natural Gas
            Distribution Company (LDC): COH will continue to be responsible for the distribution of
            natural gas supplied by Kratos pursuant to this contract. <br></br>• PUCO: Public
            Utilities Commission of Ohio.
            <br></br>• T&Cs: Kratos Gas Terms and Conditions of Service as contained in this
            statement.
            <br></br>• Default Price Plan: Kratos’ current standard variable price plan.
          </p>
          <h2 class="mt-8 text-left text-4xl font-extrabold text-gray-900 sm:text-5xl sm:leading-none md:text-xl">
            I. YOUR COLUMBIA GAS OF OHIO BILL
          </h2>
          <p class="text-left mt-3 mx-auto text-base text-blue sm:text-lg md:mt-5 md:text-sm ">
            By agreeing to have Kratos supply natural gas to you, the format of your COH bill will
            not change, except that Kratos will be identified on your statement. The terms and
            conditions of COH’s normal billing practices will not change. You do authorize Kratos to
            obtain your billing payment and usage history from COH. The customer has the right to
            also request up to 24 months of payment history for service rendered by Kratos Gas &
            Power without charge. The customer has the right to also request up to 24 months of
            payment history for service rendered by Kratos Gas & Power without charge. If you have
            questions about your understanding your bill, payment options or rate information,
            please contact COH directly at 1-800-344-4077 or visit their website at
            www.columbiagasohio.com.
          </p>
          <h2 class="mt-8 text-left text-4xl font-extrabold text-gray-900 sm:text-5xl sm:leading-none md:text-xl">
            II. YOUR SERVICE
          </h2>
          <h2 class="mt-8 text-left text-4xl font-extrabold text-gray-900 sm:text-5xl sm:leading-none md:text-xl">
            II-1. Price Plans
          </h2>
          <p class="text-left mt-3 mx-auto text-base text-blue sm:text-lg md:mt-5 md:text-sm ">
            Kratos’s price plans fall into two categories: variable and fixed. Kratos may offer some
            price plans on a pre-payment basis. The terms and conditions of service for pre-payment
            price plans may differ from or supplement those set forth in this statement. The
            specific terms and conditions for pre-payment are set forth in the Supplemental
            Disclosure Statement, which governs in the event of a conflict with these terms and
            conditions.
          </p>
          <p class="text-left mt-3 mx-auto text-base text-blue sm:text-lg md:mt-5 md:text-sm ">
            The name of your price plan for the most recent service period will be shown on your
            bill each month. Additional information on price plans is available on our Web site,
            www.kratosgp.com , or you may call a Customer Care Representative. Unless you specify
            otherwise, at the time you establish your service with Kratos Gas & Power, based on
            credit criteria you will receive gas service under our Default Price Plan.
          </p>
          <h3 class="mt-8 text-left text-4xl font-bold text-gray-500 sm:text-5xl sm:leading-none md:text-sm">
            A - Variable
          </h3>

          <p class="text-left mt-3 mx-auto text-base text-blue sm:text-lg md:mt-5 md:text-sm ">
            By agreeing to allow Kratos to supply your natural gas needs, you will be charged for
            gas at variable market prices, which may be lower than what you would be charged
            directly by COH. Under this plan, gas service is billed at a price per MCF that may
            change based on market conditions. Kratos does not use a formula to calculate the price
            per MCF. Variable monthly pricing is based on cost of gas supply purchased,
            transportation costs, administrative costs, and margin. The price per MCF used to
            calculate your gas charge is Kratos’ price in effect on the first day of your meter
            reading cycle. This price does not include applicable taxes and/or LDC charges, which
            will be billed by the LDC. You are responsible for all charges assessed by the LDC for
            gas transportation and all other applicable LDC charges, which are not included in
            Kratos’ price. Your gas service will be billed under this plan on a month-to-month
            basis.
          </p>
          <h3 class="mt-8 text-left text-4xl font-bold text-gray-500 sm:text-5xl sm:leading-none md:text-sm">
            B - Green Gas Variable Plans
          </h3>
          <p class="text-left mt-3 mx-auto text-base text-blue sm:text-lg md:mt-5 md:text-sm ">
            By agreeing to allow Kratos to supply your green natural gas needs, you will be charged
            for gas at variable market prices, which may be higher than what you would be charged
            directly by COH. Under this plan, gas service is billed at a price per MCF that may
            change based on market conditions. Kratos does not use a formula to calculate the price
            per MCF. Variable monthly pricing is based on cost of gas supply purchased,
            transportation costs, administrative costs, and margin. The price per MCF used to
            calculate your gas charge is Kratos’ price in effect on the first day of your meter
            reading cycle. Kratos will purchase carbon offsets on your behalf to offset your gas
            usage. Kratos meets the criteria to be Green-e certified and goes through an annual
            audit to ensure those standards are met. This price does not include applicable taxes
            and/or LDC charges, which will be billed by the LDC. You are responsible for all charges
            assessed by the LDC for gas transportation and all other applicable LDC charges, which
            are not included in Kratos’ price. Your gas service will be billed under this plan on a
            month-to-month basis.
          </p>

          <h3 class="mt-8 text-left text-4xl font-bold text-gray-500 sm:text-5xl sm:leading-none md:text-sm">
            C - Fixed Plan
          </h3>
          <p class="text-left mt-3 mx-auto text-base text-blue sm:text-lg md:mt-5 md:text-sm ">
            Under a fixed price plan, gas service is billed at a fixed price per MCF for the term of
            the plan. Although Kratos’s currently available fixed prices may change at any time, the
            price used to calculate your Gas Charge for the full length of the plan will be Kratos’s
            price in effect at the time you select the plan and will not change during the course of
            the contract. Your fixed price will remain in effect for all service periods with a
            beginning meter read date during the term of your plan. The price per MCF, customer
            service charge and interstate capacity charge (if applicable) for customers on a fixed
            plan will not change for the length of the plan. Any other charges under a fixed plan
            are subject to change upon 25 days’ written notice. The per MCF price on a fixed plan
            may be higher or lower than on a variable plan Kratos does not use a formula to
            calculate the price per MCF. Fixed pricing is based on cost of gas supply purchased,
            transportation costs, administrative costs, and margin.
          </p>
          <p class="text-left mt-3 mx-auto text-base text-blue sm:text-lg md:mt-5 md:text-sm ">
            When you select a fixed plan, you commit to remain on the plan for the specified period
            of time, even if you move within the COH service territory. Kratos will notify you prior
            to the expiration of your fixed plan. Commercial and Residential customers may request a
            new fixed price plan without incurring an early termination charge prior to their
            current plan’s expiration date. The respective policies, procedures, and any penalties
            for contract termination by the retail natural gas supplier and by the customer after
            the rescission period including any change in such policies, procedures, and penalties
            that will become effective upon renewal of the contract. – no fee for early termination
            is clarified, if it is to be charged then the amount needs to be clarified. If you take
            no action, you will automatically be enrolled after expiration of the fixed price plan
            on Kratos’s default variable price plan that was in effect at the beginning of your
            fixed price plan term. Your price per MCF will be the current variable price in effect
            for that default price plan. If you request and qualify for a new fixed plan, you will
            lock in Kratos’ then current fixed price, which may differ from your previous fixed
            price.
          </p>
          <p class="text-left mt-3 mx-auto text-base text-blue sm:text-lg md:mt-5 md:text-sm ">
            If you are served under a fixed plan and any of the following three circumstances occurs
            more than 45 days prior to the expiration of your fixed price plan, you will be deemed
            to have breached your fixed price plan. In each circumstance, your account will be
            assessed an Early Termination Charge:
          </p>
          <p class="pl-12 text-left mt-3 mx-auto text-base text-blue sm:text-lg md:mt-5 md:text-sm ">
            • If you switch to another price plan or change your natural gas provider at your
            current premises.<br></br>• If your service is disconnected for nonpayment and is not
            reconnected before your account closes. If your account becomes inactive and your
            service is subsequently reconnected, Kratos reserves the right to limit availability of
            price plans.<br></br> • If you voluntarily disconnect service during the term of your
            plan, including moving to a different premises.
          </p>
          <h3 class="mt-8 text-left text-4xl font-bold text-gray-500 sm:text-5xl sm:leading-none md:text-sm">
            D - Green Gas Variable Intro Price Program
          </h3>
          <p class="text-left mt-3 mx-auto text-base text-blue sm:text-lg md:mt-5 md:text-sm ">
            Kratos is currently offering customers an intro green gas price plan. By agreeing to
            allow Kratos to supply your natural gas needs under our Green Gas Intro Price Program,
            you will be charged for gas an intro green gas price of $0.999 per CCF for your gas
            service for the first month. After the first billing month, you will receive our
            month-to-month standard variable green gas rate described above. After your first 12
            months of service are up, you will become eligible for a 35% rebate on your average gas
            cost for that time period. In addition, after your first twelve months with Kratos, your
            contract will automatically renew unless you cancel. You will remain with Kratos on a
            month-to-month basis until service is terminated by you or Kratos. You will be renewed
            at the same standard monthly variable rate. If you cancel your service with Kratos at
            any time, you will not be charged a termination fee. This price does not include
            applicable taxes and/or LDC charges, which will be billed by the LDC. You are
            responsible for all charges assessed by the LDC for gas transportation and all other
            applicable LDC charges, which are not included in Kratos’ price. In addition, switching
            fees may apply under the LDC tariff. If, due to a change in market conditions, Kratos
            Gas & Power wishes to lower the price per CCF or MCF charged to the customer under an
            existing contract, it may do so without consent provided there aren’t any additional
            charges to the terms and conditions to the contract.
          </p>

          <h3 class="mt-8 text-left text-4xl font-bold text-gray-500 sm:text-5xl sm:leading-none md:text-sm">
            E - Variable Intro Price Program
          </h3>

          <p class="text-left mt-3 mx-auto text-base text-blue sm:text-lg md:mt-5 md:text-sm ">
            Kratos is currently offering customers an intro price plan. By agreeing to allow Kratos
            to supply your natural gas needs under our Variable Intro Price Program, you will be
            charged for gas at a fixed price of $0.899 per CCF for your gas service for the first
            month. After the first billing month, you will receive our month-to-month standard
            variable rate described above. After your first twelve months with Kratos, your contract
            will automatically renew unless you cancel. You will be renewed at the same standard
            monthly variable rate. If you cancel your service with Kratos at any time, you will not
            be charged a termination fee. This price does not include applicable taxes and/or LDC
            charges, which will be billed by the LDC. You are responsible for all charges assessed
            by the LDC for gas transportation and all other applicable LDC charges, which are not
            included in Kratos’ price. In addition, switching fees may apply under the LDC tariff.
            If, due to a change in market conditions, Kratos Gas & Power wishes to lower the price
            per CCF or MCF charged to the customer under an existing contract, it may do so without
            consent provided there are no other charges to the terms and conditions to the contract.
          </p>

          <h2 class="mt-8 text-left text-4xl font-extrabold text-gray-900 sm:text-5xl sm:leading-none md:text-xl">
            II-2. Term
          </h2>
          <p class="text-left mt-3 mx-auto text-base text-blue sm:text-lg md:mt-5 md:text-sm ">
            Under our Default Price Plan, Kratos will supply you with natural gas on month-to-month
            basis commencing on the first month you receive services from Kratos as confirmed by
            COH. Under our Variable Intro Rate Program, Kratos will supply you gas, starting
            January, 2017. In either case, Kratos will supply the commodity portion of your natural
            gas and COH will be Your LDC. Within 3 business days of enrollment, Kratos will notify
            the LDC to transfer your gas service. Due to the volatility of the gas market, Kratos
            reserves the right to discontinue this contract any time before enrollment. If you are
            currently a Kratos customer, Kratos reserves the right to not accept or rescind this
            enrollment or to require you to pay the applicable cancellation fee for your existing
            program to be eligible for this program. If you are a new customer then this Agreement
            may be rescinded by you without a cancellation fee by: (1) contacting the LDC in writing
            or by telephone at the number provided on the confirmation notice within 7 business days
            from the post-mark date of the confirmation notice sent by the LDC (“Rescission
            Period”), or (2) contacting Kratos in writing or by telephone within 30 days of
            enrollment with Kratos on this program (“Cancellation Period”). If you are an existing
            Kratos customer you will not receive a confirmation notice from the LDC but, in the
            event you decide to rescind enrollment in this Agreement during the Rescission Period,
            you will be returned to your previous Agreement with Kratos without penalty under this
            Agreement. During the periods described in the Rescission Period above, there is no
            cancellation fee to end this Agreement. Further, either party can cancel this Agreement
            without cancellation fee by providing notice to the other of not less than 30 days.
            Cancellation notices provided after the LDC deadline may result in an additional
            month(s) of service beyond the contract period at the applicable monthly variable price,
            which you agree to pay, as the effective date of all cancellations are subject to LDC
            guidelines. You understand that if you switch your service to another supplier or back
            to the LDC an LDC switching fee may apply under the LDC’s tariff and the LDC may charge
            a price other than the regulated sales service rate. Kratos may also terminate service
            on fourteen days written notice should you fail to pay your bill or fail to meet any
            agreed-upon payment arrangements. Your service will automatically terminate if you are
            not located within a Kratos service area, if you move outside of the Kratos service
            area, or if Kratos return you to the COH for failure to meet any of the terms contained
            herein. You will have the right to terminate service, without penalty in the event you
            relocate or as otherwise provided in this agreement.
          </p>
          <h2 class="mt-8 text-left text-4xl font-extrabold text-gray-900 sm:text-5xl sm:leading-none md:text-xl">
            II-3. Contracts
          </h2>
          <p class="text-left mt-3 mx-auto text-base text-blue sm:text-lg md:mt-5 md:text-sm ">
            Kratos does not generally require a written contract for gas service. However, when you
            select service, you are agreeing to remain on the plan for a specified period of time
            and to keep your account in good standing. See section III-2, “Term” for more
            information.
          </p>
          <h2 class="mt-8 text-left text-4xl font-extrabold text-gray-900 sm:text-5xl sm:leading-none md:text-xl">
            II-4. Account and Billing Information
          </h2>
          <p class="text-left mt-3 mx-auto text-base text-blue sm:text-lg md:mt-5 md:text-sm ">
            It is your responsibility to provide COH with accurate account information, including a
            telephone number to contact you and an accurate address to mail your gas bills. Also, if
            your account information changes at any time, it is your responsibility to notify COH of
            the changes. Kratos is not responsible for any late charges that are applied to an
            account when a customer does not receive timely bills due to incorrect account
            information provided by the customer. Kratos will not release your social security
            number or account number without your affirmative written consent in accordance with
            rules 4901:1-28-04 and 4901:-29-09 of the Administrative Code.
          </p>
          <h2 class="mt-8 text-left text-4xl font-extrabold text-gray-900 sm:text-5xl sm:leading-none md:text-xl">
            II-5. Changes to Terms and Conditions
          </h2>
          <p class="text-left mt-3 mx-auto text-base text-blue sm:text-lg md:mt-5 md:text-sm ">
            We reserve the right to change our T&Cs at any time. We will notify you of any changes
            by written notice in your bill or in a separate mailing. You may end your contract with
            Kratos Gas & Power at this time if you so choose without fees or penalty.
          </p>
          <h2 class="mt-8 text-left text-4xl font-extrabold text-gray-900 sm:text-5xl sm:leading-none md:text-xl">
            II-6. Extraordinary Events
          </h2>
          <p class="text-left mt-3 mx-auto text-base text-blue sm:text-lg md:mt-5 md:text-sm ">
            If an event occurs that delays or makes it impossible for Kratos to perform, such as an
            act of God, extraordinary weather occurrence, a facility outage on the COH or interstate
            pipeline systems, a COH failure to perform, war, civil disturbance, or national
            emergency, our performance under these T&Cs shall be excused for the duration of such
            event. Under such conditions, Kratos may elect to discontinue service immediately,
            without notice.
          </p>
          <h2 class="mt-8 text-left text-4xl font-extrabold text-gray-900 sm:text-5xl sm:leading-none md:text-xl">
            II-7. Limitation of Liability
          </h2>
          <p class="text-left mt-3 mx-auto text-base text-blue sm:text-lg md:mt-5 md:text-sm ">
            Kratos is not responsible for any losses or damages resulting from any actions/policies
            associated with COH or the interstate pipeline systems, including interruption of
            service, termination of service, defective service, or operation and maintenance of
            COH’s system or the interstate pipeline systems. Kratos is not liable for consequential,
            exemplary or punitive damages.
          </p>
          <h2 class="mt-8 text-left text-4xl font-extrabold text-gray-900 sm:text-5xl sm:leading-none md:text-xl">
            II-8. Call Monitoring Policy
          </h2>
          <p class="text-left mt-3 mx-auto text-base text-blue sm:text-lg md:mt-5 md:text-sm ">
            Telephone calls to our Customer Care Center may be monitored and/or recorded for quality
            assurance purposes. All calls for new service are recorded in compliance with PUCO
            guidelines.
          </p>
          <h2 class="mt-8 text-left text-4xl font-extrabold text-gray-900 sm:text-5xl sm:leading-none md:text-xl">
            III. Contact Information
          </h2>
          <p class="text-left mt-3 mx-auto text-base text-blue sm:text-lg md:mt-5 md:text-sm ">
            If you have any questions or inquiries regarding your gas service, please contact COH or
            Kratos at the number below. Kratos will use good faith efforts to resolve any customer
            disputes. <br></br>
            Kratos Gas & Power 225 Union Blvd., Suite 200 <br></br>Lakewood, CO 80228 <br></br>
            1-800-296-2203 <br></br>Hours of Operation: M-F 7:30 a.m. MT to 3:30 p.m. MT
            <br></br>www.kratosgp.com
          </p>
          <p class="text-left mt-3 mx-auto text-base font-bold text-blue sm:text-lg md:mt-5 md:text-sm ">
            If your complaint is not resolved after you have called Kratos Gas and Power, or for
            general utility information, residential and business customers may contact the Public
            Utilities Commission of Ohio (PUCO) for assistance at 1-800-686-7826 (toll free) from
            eight a.m. to five p.m. weekdays, or at http://www.puco.ohio.gov. Hearing or speech
            impaired customers may contact the PUCO via 7-1-1 (Ohio relay service). Residential
            customers may call the Ohio consumers' counsel (OCC) toll free at 1-877-742-5622 from
            eight thirty a.m. to five thirty p.m. weekdays, or visit the OCC website at
            www.pickocc.org or as otherwise specified by the OCC. Note: Whenever the Public
            Utilities Commission of Ohio enacts new rules prior to the publication of revised Kratos
            Terms and Conditions, those rules will supersede this statement.
          </p>

          <p class="text-left mt-3 mx-auto text-base font-bold text-blue sm:text-lg md:mt-5 md:text-sm ">
            In addition, from time to time Kratos may introduce new price plans or other programs
            that require amendments to these Terms and Conditions of Service. In such instances, you
            will be sent the revisions in advance of their effective date. The revised T&Cs may
            differ from or supplement this statement and will govern in the event of a conflict with
            this statement. In some instances, C&I customers may have written agreements with Kratos
            that provide for specific terms of service. In the event of a conflict with these T&Cs,
            those specific terms will govern.
          </p>
        </div>
      </main>
      <div class="border-b-2"></div>
    </Layout>
  );
};
export default ColumbiaTerms;
